const authorizationPdfRequests = new Map()

export const getAuthorizationPdfBlob = (url) => {
  const cachedRequest = authorizationPdfRequests.get(url)

  if (cachedRequest) {
    return cachedRequest
  }

  const request = fetch(url)
    .then((response) => {
      const canReadPdf = response.ok

      if (!canReadPdf) {
        throw new Error('Authorization PDF request failed')
      }

      return response.blob()
    })
    .catch((error) => {
      authorizationPdfRequests.delete(url)
      throw error
    })

  authorizationPdfRequests.set(url, request)

  return request
}

export const preloadAuthorizationPdfs = (urls) => {
  urls.forEach((url) => {
    const canPreloadPdf = Boolean(url)

    if (!canPreloadPdf) {
      return
    }

    getAuthorizationPdfBlob(url).catch(() => {})
  })
}
